// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-loading-block[data-v-6b8bc724]{width:100%;height:100vh;display:flex;justify-content:center;align-items:flex-start;padding-top:50px}.v-loading-page[data-v-6b8bc724]{padding-top:100px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
